import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const JACKPOT_ROUTES: Routes = [
  {
    path: 'jackpot-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.JackpotThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  // TODO: we decided to hide this page until a user aggregate table is available in PostgreSQL
  // {
  //   path: 'jackpot-users',
  //   loadComponent: () =>
  //     import('./users/containers/users.component').then(
  //       (m) => m.UsersComponent,
  //     ),
  //   canActivate: [loggedInAuthGuard, checkPermissionGuard],
  //   data: {
  //     permission: [
  //       UserRole.Admin,
  //       UserRole.ClientAdmin,
  //       UserRole.Manager,
  //       UserRole.Supervisor,
  //       UserRole.CustomerSupport,
  //     ],
  //   },
  // },
  {
    path: 'jackpot-groups',
    loadChildren: () =>
      import('./groups/groups.module').then((m) => m.GroupsModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-levels',
    loadComponent: () =>
      import('@jackpot/levels/jackpot-levels/jackpot-levels.component').then(
        (m) => m.JackpotLevelsComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-participation',
    loadComponent: () =>
      import('./participation/participation.component').then(
        (m) => m.ParticipationComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-wins',
    loadComponent: () =>
      import('./wins/wins.component').then((m) => m.WinsComponent),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-transaction-tracking',
    loadChildren: () =>
      import('./transaction-tracking/transaction-tracking.module').then(
        (m) => m.TransactionTrackingModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'jackpot-payouts',
    loadComponent: () =>
      import('./payouts/payouts.component').then((m) => m.PayoutsComponent),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-withdraws',
    loadChildren: () =>
      import('./withdraws/withdraws.module').then(
        (m) => m.JackpotWithdrawsModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'jackpot-monthly-report',
    loadChildren: () =>
      import('./monthly-report/monthly-report.module').then(
        (m) => m.MonthlyReportModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'jackpot-aggregates',
    loadChildren: () =>
      import('./aggregates/aggregates.module').then((m) => m.AggregatesModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
    },
  },
  {
    path: 'simulation',
    loadComponent: () =>
      import('./simulation/simulation.component').then(
        (m) => m.SimulationComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Supervisor,
        UserRole.Manager,
      ],
    },
  },
  {
    path: 'currencies',
    loadChildren: () =>
      import('./currencies/currencies.module').then(
        (m) => m.JackpotCurrenciesModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Supervisor,
        UserRole.Manager,
      ],
    },
  },
  {
    path: 'jackpot-tags',
    loadChildren: () =>
      import('./tags/jackpot-tags.module').then((m) => m.JackpotTagsModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Supervisor,
        UserRole.Manager,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'audit-logs',
    loadComponent: () =>
      import('./audit-logs/audit-logs.component').then(
        (m) => m.AuditLogsComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
  {
    path: 'jackpot-metrics',
    loadComponent: () =>
      import('./metrics/metrics.component').then((m) => m.MetricsComponent),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
    },
  },
  {
    path: 'tracker',
    loadComponent: () =>
      import('./tracker/tracker.component').then((m) => m.TrackerComponent),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
    },
  },
  {
    path: 'jackpot-labels/:gameUuid',
    loadComponent: () =>
      import('@jackpot/labels/jackpot-labels/jackpot-labels.component').then(
        (m) => m.JackpotLabelsComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
];
